import { siftApiClient } from '../../api/siftApiClient';
import type { BrokerChipFilterParams, ClientViewParams } from '../../api/types';
import type { BasketVin } from './BuyerBasket';

/** The slice endpoint's page cap; one bulk add stages at most this many VINs. */
export const CLUSTER_BULK_ADD_LIMIT = 200;

export type ClusterBulkAddParams =
  Pick<ClientViewParams, 'market_center' | 'seller_name' | 'auction'> &
  BrokerChipFilterParams & { match_types?: string };

/**
 * The VINs a cluster "add all" stages: exactly the set the cluster's own VIN
 * table shows. It reads the same slice endpoint with the same chip filters, so an
 * excluded condition (e.g. 2nd-chance) can never reach the basket through it.
 * The old cluster-vins call carried only the board scope and staged every unit.
 */
export async function fetchClusterBasketVins(
  clusterKey: string,
  fallback: { make?: string | null; model?: string | null },
  params: ClusterBulkAddParams,
): Promise<BasketVin[]> {
  const res = await siftApiClient.getBrokerViewSliceVins('cluster', clusterKey, {
    ...params,
    sort_by: 'urgency',
    sort_order: 'desc',
    limit: CLUSTER_BULK_ADD_LIMIT,
    offset: 0,
  });
  return (res.vins ?? []).map((v) => ({
    vin: v.vin,
    label: [v.model_year, v.make ?? fallback.make, v.model ?? fallback.model].filter(Boolean).join(' ') || v.vin,
    seller: v.seller_name ?? null,
    seller_id: v.seller_id ?? null,
    seller_loc: [v.territory_state, v.seller_zip_code].filter(Boolean).join(' · ') || null,
  }));
}
